import { render } from "./Timeout.vue?vue&type=template&id=26acd23d"
import script from "./Timeout.vue?vue&type=script&lang=ts"
export * from "./Timeout.vue?vue&type=script&lang=ts"
script.render = render

export default script